const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const brokerPensionPlanCancelPendingOrderActions = require('actions/contactCenter/brokerPensionPlanCancelPendingOrder/brokerPensionPlanCancelPendingOrder');

import BrokerPensionPlanCancelPendingOrderView from 'components/contactCenter/brokerPensionPlanCancelPendingOrder/brokerPensionPlanCancelPendingOrderView';

class BrokerPensionPlanCancelPendingOrderContainer extends React.Component {
    render() {
        return <BrokerPensionPlanCancelPendingOrderView {...this.props} />;
    }
}

BrokerPensionPlanCancelPendingOrderContainer.propTypes = {
    immBrokerPensionPlanCancelPendingOrder: PropTypes.object.isRequired,
    immBrokerContractActivities: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    immBrokerPensionPlanCancelPendingOrder: state.brokerPensionPlanCancelPendingOrder,
    immBrokerContractActivities: state.brokerContractActivities,
    immProfile: state.profile
});

module.exports.constructor = BrokerPensionPlanCancelPendingOrderContainer;
module.exports.BrokerPensionPlanCancelPendingOrderContainer = connect(
    mapStateToProps,
    {
        setVisibleStep: brokerPensionPlanCancelPendingOrderActions.setVisibleStep,
        validateStep: brokerPensionPlanCancelPendingOrderActions.validateStep,
        showCancelModal: brokerPensionPlanCancelPendingOrderActions.showCancelModal,
        reset: brokerPensionPlanCancelPendingOrderActions.reset,
        cancelPensionPlanPendingOrder: brokerPensionPlanCancelPendingOrderActions.cancelPensionPlanPendingOrder,
    }
)(BrokerPensionPlanCancelPendingOrderContainer);
